// extracted by mini-css-extract-plugin
export default {"root":"AudioViewer_root__mKhs5","player":"AudioViewer_player__JTRiM"};